function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import throttle from 'lodash.throttle';
import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import ServiceWorkerStore from './ServiceWorkerStore.js';
import IndexedDBStore from './IndexedDBStore.js';
import MetaDataStore from './MetaDataStore.js';
var packageJson = {
  "version": "3.0.2"
};
/**
 * The GoldenRetriever plugin — restores selected files and resumes uploads
 * after a closed tab or a browser crash!
 *
 * Uses localStorage, IndexedDB and ServiceWorker to do its magic, read more:
 * https://uppy.io/blog/2017/07/golden-retriever/
 */

var GoldenRetriever = /*#__PURE__*/function (_BasePlugin) {
  _inherits(GoldenRetriever, _BasePlugin);

  var _super = _createSuper(GoldenRetriever);

  function GoldenRetriever(uppy, opts) {
    var _this;

    _classCallCheck(this, GoldenRetriever);

    _this = _super.call(this, uppy, opts);

    _this.addBlobToStores = function (file) {
      if (file.isRemote) return;

      if (_this.ServiceWorkerStore) {
        _this.ServiceWorkerStore.put(file).catch(function (err) {
          _this.uppy.log('[GoldenRetriever] Could not store file', 'warning');

          _this.uppy.log(err);
        });
      }

      _this.IndexedDBStore.put(file).catch(function (err) {
        _this.uppy.log('[GoldenRetriever] Could not store file', 'warning');

        _this.uppy.log(err);
      });
    };

    _this.removeBlobFromStores = function (file) {
      if (_this.ServiceWorkerStore) {
        _this.ServiceWorkerStore.delete(file.id).catch(function (err) {
          _this.uppy.log('[GoldenRetriever] Failed to remove file', 'warning');

          _this.uppy.log(err);
        });
      }

      _this.IndexedDBStore.delete(file.id).catch(function (err) {
        _this.uppy.log('[GoldenRetriever] Failed to remove file', 'warning');

        _this.uppy.log(err);
      });
    };

    _this.replaceBlobInStores = function (file) {
      _this.removeBlobFromStores(file);

      _this.addBlobToStores(file);
    };

    _this.handleRestoreConfirmed = function () {
      _this.uppy.log('[GoldenRetriever] Restore confirmed, proceeding...'); // start all uploads again when file blobs are restored


      var _this$uppy$getState = _this.uppy.getState(),
          currentUploads = _this$uppy$getState.currentUploads;

      if (currentUploads) {
        _this.uppy.resumeAll();

        Object.keys(currentUploads).forEach(function (uploadId) {
          _this.uppy.restore(uploadId, currentUploads[uploadId]);
        });
      }

      _this.uppy.setState({
        recoveredState: null
      });
    };

    _this.abortRestore = function () {
      _this.uppy.log('[GoldenRetriever] Aborting restore...');

      var fileIDs = Object.keys(_this.uppy.getState().files);

      _this.deleteBlobs(fileIDs).then(function () {
        _this.uppy.log("[GoldenRetriever] Removed ".concat(fileIDs.length, " files"));
      }).catch(function (err) {
        _this.uppy.log("[GoldenRetriever] Could not remove ".concat(fileIDs.length, " files"), 'warning');

        _this.uppy.log(err);
      });

      _this.uppy.cancelAll();

      _this.uppy.setState({
        recoveredState: null
      });

      MetaDataStore.cleanup(_this.uppy.opts.id);
    };

    _this.handleComplete = function (_ref) {
      var successful = _ref.successful;
      var fileIDs = successful.map(function (file) {
        return file.id;
      });

      _this.deleteBlobs(fileIDs).then(function () {
        _this.uppy.log("[GoldenRetriever] Removed ".concat(successful.length, " files that finished uploading"));
      }).catch(function (err) {
        _this.uppy.log("[GoldenRetriever] Could not remove ".concat(successful.length, " files that finished uploading"), 'warning');

        _this.uppy.log(err);
      });

      _this.uppy.setState({
        recoveredState: null
      });

      MetaDataStore.cleanup(_this.uppy.opts.id);
    };

    _this.restoreBlobs = function () {
      if (_this.uppy.getFiles().length > 0) {
        Promise.all([_this.loadFileBlobsFromServiceWorker(), _this.loadFileBlobsFromIndexedDB()]).then(function (resultingArrayOfObjects) {
          var blobs = _objectSpread(_objectSpread({}, resultingArrayOfObjects[0]), resultingArrayOfObjects[1]);

          _this.onBlobsLoaded(blobs);
        });
      } else {
        _this.uppy.log('[GoldenRetriever] No files need to be loaded, only restoring processing state...');
      }
    };

    _this.type = 'debugger';
    _this.id = _this.opts.id || 'GoldenRetriever';
    _this.title = 'Golden Retriever';
    var defaultOptions = {
      expires: 24 * 60 * 60 * 1000,
      // 24 hours
      serviceWorker: false
    };
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);
    _this.MetaDataStore = new MetaDataStore({
      expires: _this.opts.expires,
      storeName: uppy.getID()
    });
    _this.ServiceWorkerStore = null;

    if (_this.opts.serviceWorker) {
      _this.ServiceWorkerStore = new ServiceWorkerStore({
        storeName: uppy.getID()
      });
    }

    _this.IndexedDBStore = new IndexedDBStore(_objectSpread(_objectSpread({
      expires: _this.opts.expires
    }, _this.opts.indexedDB || {}), {}, {
      storeName: uppy.getID()
    }));
    _this.saveFilesStateToLocalStorage = throttle(_this.saveFilesStateToLocalStorage.bind(_assertThisInitialized(_this)), 500, {
      leading: true,
      trailing: true
    });
    _this.restoreState = _this.restoreState.bind(_assertThisInitialized(_this));
    _this.loadFileBlobsFromServiceWorker = _this.loadFileBlobsFromServiceWorker.bind(_assertThisInitialized(_this));
    _this.loadFileBlobsFromIndexedDB = _this.loadFileBlobsFromIndexedDB.bind(_assertThisInitialized(_this));
    _this.onBlobsLoaded = _this.onBlobsLoaded.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(GoldenRetriever, [{
    key: "restoreState",
    value: function restoreState() {
      var savedState = this.MetaDataStore.load();

      if (savedState) {
        this.uppy.log('[GoldenRetriever] Recovered some state from Local Storage');
        this.uppy.setState({
          currentUploads: savedState.currentUploads || {},
          files: savedState.files || {},
          recoveredState: savedState
        });
        this.savedPluginData = savedState.pluginData;
      }
    }
    /**
     * Get file objects that are currently waiting: they've been selected,
     * but aren't yet being uploaded.
     */

  }, {
    key: "getWaitingFiles",
    value: function getWaitingFiles() {
      var waitingFiles = {};
      this.uppy.getFiles().forEach(function (file) {
        if (!file.progress || !file.progress.uploadStarted) {
          waitingFiles[file.id] = file;
        }
      });
      return waitingFiles;
    }
    /**
     * Get file objects that are currently being uploaded. If a file has finished
     * uploading, but the other files in the same batch have not, the finished
     * file is also returned.
     */

  }, {
    key: "getUploadingFiles",
    value: function getUploadingFiles() {
      var _this2 = this;

      var uploadingFiles = {};

      var _this$uppy$getState2 = this.uppy.getState(),
          currentUploads = _this$uppy$getState2.currentUploads;

      if (currentUploads) {
        var uploadIDs = Object.keys(currentUploads);
        uploadIDs.forEach(function (uploadID) {
          var filesInUpload = currentUploads[uploadID].fileIDs;
          filesInUpload.forEach(function (fileID) {
            uploadingFiles[fileID] = _this2.uppy.getFile(fileID);
          });
        });
      }

      return uploadingFiles;
    }
  }, {
    key: "saveFilesStateToLocalStorage",
    value: function saveFilesStateToLocalStorage() {
      var filesToSave = _objectSpread(_objectSpread({}, this.getWaitingFiles()), this.getUploadingFiles()); // If all files have been removed by the user, clear recovery state


      if (Object.keys(filesToSave).length === 0) {
        if (this.uppy.getState().recoveredState !== null) {
          this.uppy.setState({
            recoveredState: null
          });
        }

        MetaDataStore.cleanup(this.uppy.opts.id);
        return;
      } // We dont’t need to store file.data on local files, because the actual blob will be restored later,
      // and we want to avoid having weird properties in the serialized object.
      // Also adding file.isRestored to all files, since they will be restored from local storage


      var filesToSaveWithoutData = {};
      Object.keys(filesToSave).forEach(function (file) {
        if (filesToSave[file].isRemote) {
          filesToSaveWithoutData[file] = _objectSpread(_objectSpread({}, filesToSave[file]), {}, {
            isRestored: true
          });
        } else {
          filesToSaveWithoutData[file] = _objectSpread(_objectSpread({}, filesToSave[file]), {}, {
            isRestored: true,
            data: null,
            preview: null
          });
        }
      });
      var pluginData = {}; // TODO Find a better way to do this?
      // Other plugins can attach a restore:get-data listener that receives this callback.
      // Plugins can then use this callback (sync) to provide data to be stored.

      this.uppy.emit('restore:get-data', function (data) {
        Object.assign(pluginData, data);
      });

      var _this$uppy$getState3 = this.uppy.getState(),
          currentUploads = _this$uppy$getState3.currentUploads;

      this.MetaDataStore.save({
        currentUploads: currentUploads,
        files: filesToSaveWithoutData,
        pluginData: pluginData
      });
    }
  }, {
    key: "loadFileBlobsFromServiceWorker",
    value: function loadFileBlobsFromServiceWorker() {
      var _this3 = this;

      if (!this.ServiceWorkerStore) {
        return Promise.resolve({});
      }

      return this.ServiceWorkerStore.list().then(function (blobs) {
        var numberOfFilesRecovered = Object.keys(blobs).length;

        if (numberOfFilesRecovered > 0) {
          _this3.uppy.log("[GoldenRetriever] Successfully recovered ".concat(numberOfFilesRecovered, " blobs from Service Worker!"));

          return blobs;
        }

        _this3.uppy.log('[GoldenRetriever] No blobs found in Service Worker, trying IndexedDB now...');

        return {};
      }).catch(function (err) {
        _this3.uppy.log('[GoldenRetriever] Failed to recover blobs from Service Worker', 'warning');

        _this3.uppy.log(err);

        return {};
      });
    }
  }, {
    key: "loadFileBlobsFromIndexedDB",
    value: function loadFileBlobsFromIndexedDB() {
      var _this4 = this;

      return this.IndexedDBStore.list().then(function (blobs) {
        var numberOfFilesRecovered = Object.keys(blobs).length;

        if (numberOfFilesRecovered > 0) {
          _this4.uppy.log("[GoldenRetriever] Successfully recovered ".concat(numberOfFilesRecovered, " blobs from IndexedDB!"));

          return blobs;
        }

        _this4.uppy.log('[GoldenRetriever] No blobs found in IndexedDB');

        return {};
      }).catch(function (err) {
        _this4.uppy.log('[GoldenRetriever] Failed to recover blobs from IndexedDB', 'warning');

        _this4.uppy.log(err);

        return {};
      });
    }
  }, {
    key: "onBlobsLoaded",
    value: function onBlobsLoaded(blobs) {
      var _this5 = this;

      var obsoleteBlobs = [];

      var updatedFiles = _objectSpread({}, this.uppy.getState().files); // Loop through blobs that we can restore, add blobs to file objects


      Object.keys(blobs).forEach(function (fileID) {
        var originalFile = _this5.uppy.getFile(fileID);

        if (!originalFile) {
          obsoleteBlobs.push(fileID);
          return;
        }

        var cachedData = blobs[fileID];
        var updatedFileData = {
          data: cachedData,
          isRestored: true,
          isGhost: false
        };
        updatedFiles[fileID] = _objectSpread(_objectSpread({}, originalFile), updatedFileData);
      }); // Loop through files that we can’t restore fully — we only have meta, not blobs,
      // set .isGhost on them, also set isRestored to all files

      Object.keys(updatedFiles).forEach(function (fileID) {
        if (updatedFiles[fileID].data === null) {
          updatedFiles[fileID] = _objectSpread(_objectSpread({}, updatedFiles[fileID]), {}, {
            isGhost: true
          });
        }
      });
      this.uppy.setState({
        files: updatedFiles
      });
      this.uppy.emit('restored', this.savedPluginData);

      if (obsoleteBlobs.length) {
        this.deleteBlobs(obsoleteBlobs).then(function () {
          _this5.uppy.log("[GoldenRetriever] Cleaned up ".concat(obsoleteBlobs.length, " old files"));
        }).catch(function (err) {
          _this5.uppy.log("[GoldenRetriever] Could not clean up ".concat(obsoleteBlobs.length, " old files"), 'warning');

          _this5.uppy.log(err);
        });
      }
    }
  }, {
    key: "deleteBlobs",
    value: function deleteBlobs(fileIDs) {
      var _this6 = this;

      var promises = [];
      fileIDs.forEach(function (id) {
        if (_this6.ServiceWorkerStore) {
          promises.push(_this6.ServiceWorkerStore.delete(id));
        }

        if (_this6.IndexedDBStore) {
          promises.push(_this6.IndexedDBStore.delete(id));
        }
      });
      return Promise.all(promises);
    }
  }, {
    key: "install",
    value: function install() {
      this.restoreState();
      this.restoreBlobs();
      this.uppy.on('file-added', this.addBlobToStores);
      this.uppy.on('file-editor:complete', this.replaceBlobInStores);
      this.uppy.on('file-removed', this.removeBlobFromStores); // TODO: the `state-update` is bad practise. It fires on any state change in Uppy
      // or any state change in any of the plugins. We should to able to only listen
      // for the state changes we need, somehow.

      this.uppy.on('state-update', this.saveFilesStateToLocalStorage);
      this.uppy.on('restore-confirmed', this.handleRestoreConfirmed);
      this.uppy.on('restore-canceled', this.abortRestore);
      this.uppy.on('complete', this.handleComplete);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.off('file-added', this.addBlobToStores);
      this.uppy.off('file-editor:complete', this.replaceBlobInStores);
      this.uppy.off('file-removed', this.removeBlobFromStores);
      this.uppy.off('state-update', this.saveFilesStateToLocalStorage);
      this.uppy.off('restore-confirmed', this.handleRestoreConfirmed);
      this.uppy.off('restore-canceled', this.abortRestore);
      this.uppy.off('complete', this.handleComplete);
    }
  }]);

  return GoldenRetriever;
}(BasePlugin);

export { GoldenRetriever as default };
GoldenRetriever.VERSION = packageJson.version;